// src/styles/sidebarTheme.js
export const sidebarColors = {
    primaryMain: '#0077b6',
    primaryLight: '#00b4d8',
    primarySoft: 'rgba(0, 180, 216, 0.1)',
    borderSoft: 'rgba(0, 180, 216, 0.2)',
    trackSoft: '#caf0f8',
    accent: '#90e0ef',
    danger: '#ff5656',
    bgGrad: 'linear-gradient(to bottom, #ffffff 0%, #f5fbff 100%)',
    titleGrad: 'linear-gradient(to right, #0077b6, #00b4d8)',
  };
  